import axios from 'axios';
import { Match } from '@repo/types/match';
import API from '../endpoints';
import { QueryObserverOptions, useQuery } from '@tanstack/react-query';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 60 seconds frontend cache for fetching matches
const CACHE_TIME = 60 * 1000;

export const useMatchByIdQuery = (id: string | undefined, options?: Pick<QueryObserverOptions, 'enabled'>) => {
  return useQuery({
    queryKey: ['match', { id: id! }],
    queryFn: async (): Promise<Match | null> => {
      if (id) {
        return fetchMatchById(id);
      }
      return null;
    },
    staleTime: !accessToken ? CACHE_TIME : undefined,
    enabled: typeof options?.enabled !== 'undefined' ? Boolean(options.enabled) : !!id,
  });
};

export const fetchMatchById = async (id: string): Promise<Match | null> => {
  const { data } = await axios.get<Match | null>(`${API.endpoints.match}/${id}`);
  return data;
};
